import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminMeterGrid(props) {
    const formmeterRef = useRef(null)
    const [meteritem, setMeteritem] = useState({
        id: 0,
        ipaddress: '',
        modbus_id: 0,
        serial_no: '',
        edittime: ''
    });
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_meter, setModal_meter] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        api_get_list()
        return () => {
            setMeteritem({});
        }
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading grid meter." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/gridmeter/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setMeteritem(response.data.meter)
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_save_data() {
        var formelement = formmeterRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('ipaddress', meteritem.ipaddress)
            formData.append('modbus_id', meteritem.modbus_id)
            formData.append('serial_no', meteritem.serial_no)

            setmodal_load({ enable: true, message: "Saving grid meter." })
            await sleep(500)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/gridmeter/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_meter(false)
                    setMeteritem({
                        id: 0,
                        area_name: '',
                        ipaddress: '',
                        modbus_id: 0
                    })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your grid meter has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.meter !== undefined) {
                        setMeteritem(response.data.meter)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_meter(false)
                    setMeteritem({
                        id: 0,
                        area_name: '',
                        ipaddress: '',
                        modbus_id: 0
                    })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-tachometer-alt"></i> Grid Meter</h4>
                                    <p className="mb-3">Manage grid meters</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                            </div>
                        </div>
                    </div>

                    <form ref={formmeterRef} className='mt-3 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data">
                        <div className="row">
                            <h6>Grid Meter Connection</h6>
                            <div className="col-md-3 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="ipaddress">IP Address (IPV4)</label>
                                    <input type="text" className="form-control" id="ipaddress" name="ipaddress" pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$" value={meteritem.ipaddress} onChange={(e) => {
                                        setMeteritem({
                                            ...meteritem,
                                            ipaddress: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                            <div className="col-md-3 col-xl-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id">Modbus ID</label>
                                    <input type="number" className="form-control" id="modbus_id" name="modbus_id" min={1} max={256} value={meteritem.modbus_id} onChange={(e) => {
                                        setMeteritem({
                                            ...meteritem,
                                            modbus_id: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-xl-4">
                                <div className="form-group mb-3">
                                    <label htmlFor="serial_no">Meter Serial No.</label>
                                    <input type="text" className="form-control" id="serial_no" name="serial_no" value={meteritem.serial_no} onChange={(e) => {
                                        setMeteritem({
                                            ...meteritem,
                                            serial_no: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6 col-xl-4">
                                <div className="form-group">
                                    <label htmlFor="edittime">Edit Time</label>
                                    <input type="text" className="form-control" id="edittime" name="edittime" value={meteritem.edittime} readOnly />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-3 mb-1 mt-3">
                            <button className="btn btn-warning btn-sm" type="button" onClick={() => { api_save_data() }}><i className="fe-save"></i> Save</button>
                        </div>
                    </div>
                    <hr className="new-section-xs" />

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminMeterGrid